<template>
  <!-- 新闻动态 -->
  <div class="News" v-loading="loading">
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>新闻动态</li>
        <li>绿色生态产业链全方位数据专家</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span>首页&nbsp;></span>
          <span>新闻动态</span>
        </div>
      </div>
    </div>
    <div class="News_box" id="main-content">
      <div class="contentBox">
        <div class="itemBox">
          <div
            class="item"
            v-for="(item, index) in arr"
            :key="index"
            @click="goPage(item)"
          >
            <img :src="item.imgUrl" alt="" />
            <ul class="itemRight">
              <li>
                {{ item.name }}
              </li>
              <li>
                {{ item.introduction }}
              </li>
              <li>
                {{ item.createTime }}
              </li>
            </ul>
          </div>
          <el-pagination
            class="page"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :current-page="page"
            :page-size="pageSize"
            :page-sizes="[5, 10, 20, 50]"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCenter from '@/api/articleCenter.js'
export default {
  name: 'News',
  data () {
    return {
      arr: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false
    }
  },
  methods: {
    goPage (item) {
      if (item && item.id) {
        this.$router.push({
          name: 'NewsDetails',
          query: {
            articleCenterId: item.id.toString()
          }
        })
      } else {
        this.$message.error('新闻数据异常，无法查看详情')
      }
    },
    async getList () {
      this.loading = true
      const params = {
        name: '',
        startTime: '',
        endTime: '',
        page: this.page,
        pageSize: this.pageSize,
        caseType: '',
        articleType: 2,
        betterStatus: 1
      }
      const { code, msg, data, total } = await ArticleCenter.queryAcList(
        params
      )
      if (code === 200) {
        if (data.length > 0) {
          this.arr = data.filter(item => item.startStatus === 1)
          this.total = total
        }
      } else {
        this.$message.error(msg)
      }
      this.loading = false
    },
    handleCurrentChange (page) {
      this.page = page
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.page = 1
      this.getList()
    }
  },
  mounted () {
    this.getList()

    // this.$nextTick(() => {
    //   const mainContent = document.getElementById('main-content')
    //   if (mainContent) {
    //     const breadcrumb = document.querySelector('.breadcrumb')
    //     const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48
    //     const bannerHeight = 274
    //
    //     window.scrollTo({
    //       top: bannerHeight + breadcrumbHeight - 10,
    //       behavior: 'smooth'
    //     })
    //   }
    // })
  }
}
</script>

<style scoped lang="scss">
.News {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }

        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;

    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;

      img {
        width: 22px;
        height: 20px;
      }

      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }

      span {
        font-size: 16px;

        &:nth-child(1) {
          color: #666666;
        }

        &:nth-child(2) {
          color: #2b8737;
        }
      }
    }
  }
  .News_box {
    width: 100%;
    min-height: 400px; /* 自适应高度，改为最小高度保证背景填充 */
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      background-color: #fff;
      margin-top: 20px;
      padding: 0 28px;
      /* 移除 overflow: auto，避免内部滚动条，让整个页面滚动 */
      overflow: visible;
      margin-bottom: 20px;
      padding-bottom: 20px;
      .itemBox {
        width: 100%;
        /* 移除固定高度 950px，改为自动撑开 */
        height: auto;
        .item {
          width: 100%;
          height: 184px;
          display: flex;
          justify-content: space-between;
          margin-top: 28px;
          &:hover {
            cursor: pointer;
            opacity: 0.7;
          }
          img {
            width: 286px;
            height: 184px;
          }
          .itemRight {
            width: 830px;
            height: 160px;
            padding: 20px 0;
            li {
              width: 100%;
              &:nth-child(1) {
                height: 20px;
                font-size: 18px;
                font-weight: 700;
              }
              &:nth-child(2) {
                height: 100px;
                font-size: 14px;
                line-height: 24px;
                color: #999999;
                overflow: auto;
                margin-top: 10px;
              }
              &:nth-child(3) {
                height: 16px;
                font-size: 14px;
                color: #999999;
              }
            }
          }
        }
      }
    }
  }
  .page {
    width: 100%;
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
}
</style>

<style>
/* 分页组件全局样式 */
.News .page .el-pagination.is-background .el-pager li:not(.disabled):hover {
  background-color: #1c7e28 !important;
}

.News .page .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1c7e28 !important;
}

.News .page .el-pagination__jump .el-input__inner:focus {
  border-color: #1c7e28 !important;
}

.News .page .el-select .el-input.is-focus .el-input__inner {
  border-color: #1c7e28 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/news/News.vue